const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/notifications/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import i18n from '@/lib/translations/i18n';
export const Route = createFileRoute('/(app)/org/$org/notifications/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: z.object({
    view: z.enum(['inbox', 'unread']).catch('inbox')
  }),
  loader: (): LoaderData => ({
    crumb: i18n.t($ => $.notifications.inbox.title)
  }),
  staticData: {
    hideChrome: true
  }
});